"use client";

import { c as _c } from "react/compiler-runtime";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { createPossessionStr } from "@/helpers/Helpers";
import { useIdentity } from "@/hooks/useIdentity";
import { useParams } from "next/navigation";
import { useEffect, useState } from "react";
export enum ProfileNameType {
  POSSESSION = "POSSESSION",
  DEFAULT = "DEFAULT",
}
export default function ProfileName(t0) {
  const $ = _c(16);
  const {
    type
  } = t0;
  const params = useParams();
  let t1;
  if ($[0] !== params?.user) {
    t1 = params?.user?.toString().toLowerCase();
    $[0] = params?.user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOrWallet = t1;
  let t2;
  if ($[2] !== handleOrWallet) {
    t2 = {
      handleOrWallet,
      initialProfile: null
    };
    $[2] = handleOrWallet;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    profile
  } = useIdentity(t2);
  let t3;
  if ($[4] !== type) {
    t3 = profile_0 => {
      switch (type) {
        case ProfileNameType.POSSESSION:
          {
            return createPossessionStr(profile_0?.handle ?? null);
          }
        case ProfileNameType.DEFAULT:
          {
            return profile_0?.handle ?? "";
          }
        default:
          {
            assertUnreachable(type);
            return "";
          }
      }
    };
    $[4] = type;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const createName = t3;
  const t4 = profile ?? null;
  let t5;
  if ($[6] !== createName || $[7] !== t4) {
    t5 = createName(t4);
    $[6] = createName;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const [name, setName] = useState(t5);
  let t6;
  if ($[9] !== createName || $[10] !== profile) {
    t6 = () => {
      setName(createName(profile ?? null));
    };
    $[9] = createName;
    $[10] = profile;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== profile) {
    t7 = [profile];
    $[12] = profile;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  if ($[14] !== name) {
    t8 = <>{name}</>;
    $[14] = name;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}